import type { FaireProductEntity } from "../../entity_types/product";

export const p_722ywtx5b8: FaireProductEntity = {
  token: "p_722ywtx5b8",
  type: "product",
  name: "Rhodium Twisted Knot Cuff Bracelet",
  brandToken: "b_nnzc8s53xn",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/093ed4907d66cb1c1633406fc650c649bff412893bf14ba9205823b7d9b4c97e.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.5,
  description:
    "Immerse yourself in the timeless sophistication of Juniper Wish with our Rhodium Twisted Knot Cuff Bracelet. This one-size-fits-all piece is perfect for those elevated casual occasions, beautifully merging classic and modern sensibilities. Its intricate design celebrates femininity and grace, making it a cherished part of your style journey. Experience the exceptional craftsmanship that is synonymous with our Vancouver-based, family-owned brand.",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:45.293Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
